import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-editor-code",
  "use": "icon-sequence-editor-code-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"none\" id=\"icon-sequence-editor-code\">\n  <path d=\"M6.00863 4.66406L2.67529 7.9974L6.00863 11.3307M10.0086 4.66406L13.342 7.9974L10.0086 11.3307\" stroke=\"#475467\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol